var event = new CustomEvent('loadForm');

document.addEventListener("pjax:complete", function() {

  /* trigger loadForm event to load scripts */
  if (jQuery(".gform_wrapper").length) {
    document.dispatchEvent(event);

    var formId = jQuery( ".form-container" ).attr('form-id');
    jQuery(document).trigger('gform_post_render', formId);

    /* if form has a datepicker field, load it */
    if (jQuery(".datepicker").length) {
      gformInitDatepicker();
      jQuery('.datepicker').attr('readonly', '');
    }
  }

  /* if form has a reCaptcha field installed, load all scripts */
  if (jQuery(".ginput_recaptcha").length && !jQuery("#gform_recaptcha-js").length) {
    jQuery('body').append('<script type="text/javascript" src="https://www.google.com/recaptcha/api.js?hl=nl&amp;render=explicit" defer="" onload="" id="gform_recaptcha-js"></script>')
  }

});

document.addEventListener("DOMContentLoaded", function() {


  if (jQuery(".gform_wrapper").length) {
    document.dispatchEvent(event);
    if (jQuery(".datepicker").length) {
      jQuery('.datepicker').attr('readonly', '');
    }
  }

  jQuery(document).bind('gform_post_render', function() {
    var gfRecaptchaPoller = setInterval(function() {
      if (!window.grecaptcha || !window.grecaptcha.render) {
        return;
      }
      renderRecaptcha();
      clearInterval(gfRecaptchaPoller);
    }, 100);
  });

});
